import cx from 'classnames';
import React from 'react';
import styles from './fieldset.module.scss';

type Props = {
	title: string;
	height?: number | string;
	width?: number | string;
	className?: string;
	children?: React.ReactNode;
};

const Fieldset: React.FC<Props> = ({ title, children, height, width, className }) => {
	const style: React.CSSProperties = { height, width };

	return (
		<fieldset className={cx(styles.fieldSet, className)} style={style}>
			<legend className={styles.legend}>{title}</legend>
			{children}
		</fieldset>
	);
};

export { Fieldset };
